let csrfToken: string | null = null;

export function clearCsrf(): void {
  csrfToken = null;
}

async function getCsrf(): Promise<string> {
  if (csrfToken) return csrfToken;
  const res = await fetch('/csrf-token');
  if (!res.ok) {
    throw new Error(`Failed to fetch CSRF token: ${res.statusText}`);
  }
  const data: unknown = await res.json();
  if (
    typeof data === 'object' &&
    data !== null &&
    'token' in data &&
    typeof data.token === 'string'
  ) {
    csrfToken = data.token;
    return csrfToken;
  }
  throw new Error('Invalid CSRF token response format');
}

export async function $post<T = unknown>(
  url: string,
  body: Record<string, unknown> = {}
): Promise<T> {
  const xCsrfToken = await getCsrf();
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-csrf-token': xCsrfToken,
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(`HTTP error ${res.status}: ${res.statusText}`);
  }
  const data: T = await res.json();
  return data;
}

export async function $get<T = unknown>(url: string): Promise<T> {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`HTTP error ${res.status}: ${res.statusText}`);
  }
  const data: T = await res.json();
  return data;
}

export async function $delete<T = unknown>(url: string): Promise<T> {
  const xCsrfToken = await getCsrf();
  const res = await fetch(url, {
    method: 'DELETE',
    headers: {
      'x-csrf-token': xCsrfToken,
    },
  });
  if (!res.ok) {
    throw new Error(`HTTP error ${res.status}: ${res.statusText}`);
  }
  const data: T = await res.json();
  return data;
}
